import { ReactNode } from "react";

import { useTheme } from "styled-components";

import { Flex, FlexProps } from "./FlexBox";
import { Typography } from "./Typography";

interface BadgeProps extends FlexProps {
  children: ReactNode;
  badgeNumber: number;
}

export const Badge = ({ children, badgeNumber, ...rest }: BadgeProps) => {
  const theme = useTheme();
  return (
    <Flex position="relative">
      {badgeNumber > 0 ? (
        <Flex
          bgColor={rest.bgColor || theme.colors.error.dark}
          position="absolute"
          top="-30%"
          right="-10%"
          borderRadius="10px"
          minWidth="20px"
          height="20px"
          padding="0 0.2rem"
          {...rest}
        >
          <Typography size="0.8rem" color={rest.color || theme.colors.common.white}>
            {badgeNumber}
          </Typography>
        </Flex>
      ) : null}
      {children}
    </Flex>
  );
};
